module.exports = __webpack_public_path__ + "img/vscode.5321c1c9.jpg";